import React, {Component, PropTypes} from 'react'
import stylesDocCss from './documents.scss'
import Modal from 'react-modal'
//import cs from 'classnames'
import nesProp from 'nested-property'
import i18n from 'lib/i18n'
import uuidv4 from 'uuid/v4'
// import * as c from 'state/constants'

// init translations
const _ = i18n('dswizard')
export default class AreYouSureModal extends Component {
    static propTypes = {
        isOpenAreYouSure: PropTypes.object,
        isOpen: PropTypes.bool,
        style: PropTypes.object,
        contentLabel: PropTypes.string,
        didClose: PropTypes.func,
        noCancelButton: PropTypes.bool
    }

    /**
     * Content of are you sure modal
     */
    render() {
        const {isOpenAreYouSure, style, isOpen, contentLabel, didClose} = this.props

        let htmlContent = false
        let message1 = nesProp.get(isOpenAreYouSure, "message1") || ""
        let isErrorMessage = nesProp.get(isOpenAreYouSure, "isErrorMessage") || false

        if (isOpenAreYouSure && message1 && typeof message1 === 'string') {
            if (message1.includes("<!DOCTYPE HTML PUBLIC")) {
                htmlContent = message1
            }
        }

        return (
            <Modal
                isOpen={isOpen}
                style={style}
                contentLabel={contentLabel}
                key={"AreYouSureModalKey" + uuidv4()}
            >
                <div className={stylesDocCss.documentsModalContent} key="rootComponentOfDsWizardAreYouSureModalRender">
                    <span className={stylesDocCss.title}>{isOpenAreYouSure.title}</span>
                        <span className={isErrorMessage? stylesDocCss.errorMessage : stylesDocCss.message}>
                            <div className={stylesDocCss.resendModalContainer}>
                                {isOpenAreYouSure && <div>{isOpenAreYouSure.message}</div>}
                                {isOpenAreYouSure && message1 &&
                                    <div key="detailsDivInModal">
                                        {_('details') + ": "}
                                        {htmlContent && <div key="htmlContent" dangerouslySetInnerHTML={{__html: String(htmlContent).toString()}}></div>}
                                        {!htmlContent && <div key="moHtmlContent"> {message1} </div>}
                                    </div>
                                }
                                {isOpenAreYouSure && isOpenAreYouSure.message2 && <div>{isOpenAreYouSure.message2}</div>}
                            </div>
                        </span>
                    <div className={stylesDocCss.documentsModalButtons}>
                            {!(isOpenAreYouSure && isOpenAreYouSure.noCancelButton === true) &&
                                <div
                                    onClick={() => {
                                        if (typeof isOpenAreYouSure.callBackCancel === 'function') {
                                            isOpenAreYouSure.callBackCancel()
                                            didClose()
                                        }
                                    }}
                                    className={stylesDocCss.cancel}
                                >
                                    {_("cancel")}
                                </div>
                            }
                            <div
                                onClick={()=>{
                                    if (typeof isOpenAreYouSure.callBackOk === 'function') {
                                        isOpenAreYouSure.callBackOk()
                                        didClose()
                                    }
                                }}
                                className={stylesDocCss.greenButton + " enabled"}
                            >
                                {_("ok")}
                            </div>
                        </div>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/AreYouSureModal.jsx